export default "__VITE_ASSET__CdZ_KYVy__"